/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

const DATATIP_OFFSET = 8;

export const calculateOffset = (
  isRtl: boolean,
  width: number,
  bounds?: {
    x: number;
    y: number;
    width: number;
    height: number;
  }
) => {
  if (!bounds) {
    return { mainAxis: DATATIP_OFFSET, crossAxis: DATATIP_OFFSET };
  }
  const center = {
    x: bounds.x + bounds.width / 2,
    y: bounds.y + bounds.height / 2
  };
  return {
    mainAxis: -center.y + DATATIP_OFFSET,
    crossAxis: isRtl ? width - center.x : center.x
  };
};
